export default __webpack_public_path__ + "static/media/corevalue-sensible.4c433637.png";